import React from 'react';
import i18n from 'i18n';
import styled from 'styled-components';

import Modal, { RowsContainer } from 'components/Modal';

const UninstallContentContainer = styled(RowsContainer)`
  text-align: center;
  margin-bottom: 25px;
`;

export const UninstallModal = ({ appName, onClose, onConfirm }) => (
  <Modal
    id={`UninstallModal`}
    title={i18n('component.UninstallModal.Title')({ appName })}
    onClose={onClose}
    contentCenter={
      <UninstallContentContainer>
        {i18n('component.UninstallModal.Content')()}
      </UninstallContentContainer>
    }
    buttons={[
      {
        text: i18n('component.UninstallModal.CancelText')(),
        onClick: onClose,
        testType: 'cancel-button',
        id: 'uninstall-button-cancel'
      },
      {
        text: i18n('component.UninstallModal.UninstallText')(),
        onClick: onConfirm,
        highlight: true,
        testType: 'uninstall-button',
        id: 'uninstall-button-ok'
      }
    ]}
  />
);
